import TabBodies from "@src/components/elements/shared/tab/TabBodies";
import TabHeaders from "@src/components/elements/shared/tab/TabHeaders";
import React, { ReactElement, useEffect, useState } from "react";

interface HeaderProps {
  children: ReactElement[] | ReactElement;
  activeTab: string;
  setActiveTab?: (index: string) => void;
  isSubTab?: boolean;
}

interface BodyProps {
  children: ReactElement[] | ReactElement;
  activeTab: string;
  isPersistent?: boolean;
}

type Props = {
  children: ReactElement[] | ReactElement;
  defaultTab?: string;
  isSubTab?: boolean;
  isPersistent?: boolean;
};

/**
 * component to control tabs
 *
 * @param defaultTab Selected tab by default
 * @param isSubTab Tab menu is using sub tab styles
 * @param isPersistent Keeps tab content rendered when hidden
 */
const TabController: React.FC<Props> = ({
  children,
  defaultTab,
  isSubTab = false,
  isPersistent = false,
}: Props) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    setActiveTab(defaultTab);
  }, [defaultTab]);

  return (
    <>
      {React.Children.map(children, child => {
        if ((child as ReactElement<ReactElement[] | ReactElement>).type === TabHeaders) {
          return React.cloneElement(child as ReactElement<HeaderProps>, {
            activeTab,
            setActiveTab,
            isSubTab,
          });
        } else if ((child as ReactElement<ReactElement[] | ReactElement>).type === TabBodies) {
          return React.cloneElement(child as ReactElement<BodyProps>, {
            activeTab,
            isPersistent,
          });
        } else return child;
      })}
    </>
  );
};

export default TabController;
